import { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import PendingAdjustmentDetailsHeader from '../../components/PendingAdjustmentDetailsHeader'
import PendingAdjustmentDetailsTable from '../../components/PendingAdjustmentDetailsTable'
import { selectAdjustmentDetails } from '../../StockAdjustmentInBatchSeletor'
import { actions } from '../../StockAdjustmentInBatchState'

export default () => {
  const history = useHistory()
  const { adjustmentId } = useParams<{ adjustmentId?: string }>()
  const adjustmentsDetail = useSelector(selectAdjustmentDetails)
  const dispatch = useDispatch()

  const handleClickBackButton = useCallback(() => {
    history.push('/adjustments/pending-adjustments/')
  }, [history])

  useEffect(() => {
    dispatch(actions.getAdjustmentDetails(Number(adjustmentId)))
  }, [dispatch, adjustmentId])

  return (
    <>
      <PendingAdjustmentDetailsHeader
        pendingAdjustment={adjustmentsDetail}
        adjustmentId={Number(adjustmentId)}
        handleClickBackButton={handleClickBackButton}
      />
      <PendingAdjustmentDetailsTable data={adjustmentsDetail.items} />
    </>
  )
}
